import { TRAINING_CERTIFICATIONS } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';

export interface QuizAnswer {
	questionId: number;
	selectedIndex: number;
}

export interface TrainingCertificationSubmitRequest {
	trainingId: string;
	score: number;
	totalQuestions: number;
	passed: boolean;
	answersJson?: string;
}

export interface UserTrainingCertificationViewModel {
	id: string;
	trainingId: string;
	score: number;
	totalQuestions: number;
	passed: boolean;
	completedAt: string;
}

export const TrainingCertification = {
	submitTrainingResult: (data: TrainingCertificationSubmitRequest) =>
		FetchAPI.postJson({
			urlStr: TRAINING_CERTIFICATIONS,
			data,
		}),
	getMyCertifications: () =>
		FetchAPI.getJson({
			urlStr: `${TRAINING_CERTIFICATIONS}/me`,
		}),
};
